// extracted by mini-css-extract-plugin
export default {"page-results":"PageResults_page-results__xk-sF","section-results":"PageResults_section-results__OgeTW"};